// dochadzkaOffline.js — OFFLINE fronta dochádzky (mview_appka_v1, 17. 10. 2026; ústava 121.3: „vždy aj offline, pri prvej
// možnosti odoslať na server“). Rovnaký vzor ako offline/diaryOffline.js (Dalux Outbox): IndexedDB 'kamir_dochadzka',
// 'outbox' = neodoslané úkony (príchod, odchod), 'kv' = posledný známy stav dňa. client_uid = idempotencia — server
// (POST /api/dochadzka) ten istý úsek nezdvojí. Odchod k úseku, ktorý ešte nemá id zo servera, čaká, kým jeho príchod
// neprejde; id sa dohľadá podľa client_uid v GET /api/dochadzka/dnes/:emp.
import { fetchAuth } from '../auth/fetchAuth.js'

let idb = null
function idbOpen() {
  return new Promise((res, rej) => {
    if (idb) return res(idb)
    const q = indexedDB.open('kamir_dochadzka', 1)
    q.onupgradeneeded = () => {
      const d = q.result
      if (!d.objectStoreNames.contains('kv')) d.createObjectStore('kv')
      if (!d.objectStoreNames.contains('outbox')) d.createObjectStore('outbox', { keyPath: 'client_uid' })
    }
    q.onsuccess = () => { idb = q.result; res(idb) }
    q.onerror = () => rej(q.error)
  })
}
const tx = (store, mode, fn) => idbOpen().then(d => new Promise(res => { const t = fn(d.transaction(store, mode).objectStore(store)); t.onsuccess = () => res(t.result); t.onerror = () => res(undefined) })).catch(() => undefined)
export const dkvGet = (k) => tx('kv', 'readonly', s => s.get(k))
export const dkvSet = (k, v) => tx('kv', 'readwrite', s => s.put(v, k))
export const doAll = () => tx('outbox', 'readonly', s => s.getAll()).then(r => r || [])
export const doPut = (item) => tx('outbox', 'readwrite', s => s.put(item))
export const doDel = (uid) => tx('outbox', 'readwrite', s => s.delete(uid))
export const noveUid = () => 'A' + Date.now().toString(36) + Math.random().toString(36).slice(2, 9)

// položka outboxu: { client_uid, typ: 'prichod'|'odchod', body, att_id?, za_uid?, employee_id, cas }
let flushing = false
export async function flushDochadzka() {
  if (flushing || !navigator.onLine) return { sent: 0 }
  flushing = true
  let sent = 0
  try {
    const items = (await doAll()).sort((a, b) => String(a.cas || '').localeCompare(String(b.cas || '')))
    for (const it of items) {
      try {
        if (it.typ === 'prichod') {
          const r = await fetchAuth('/api/dochadzka/', { method: 'POST', body: JSON.stringify({ ...it.body, client_uid: it.client_uid }) })
          const d = await r.json().catch(() => ({}))
          if (r.ok) { await dkvSet('id:' + it.client_uid, d.id); await doDel(it.client_uid); sent++ }
          else if (r.status >= 400 && r.status < 500) { await doPut({ ...it, err: d.error || ('Chyba ' + r.status) }) }
          else break
          continue
        }
        if (it.typ === 'odchod') {
          let id = it.att_id || (it.za_uid ? await dkvGet('id:' + it.za_uid) : '')
          if (!id && it.za_uid && it.employee_id) {
            const dn = await fetchAuth('/api/dochadzka/dnes/' + encodeURIComponent(it.employee_id)).then(x => x.ok ? x.json() : null).catch(() => null)
            const row = dn && (dn.rows || []).find(x => x.client_uid === it.za_uid)
            if (row) id = row.id
          }
          if (!id) { continue }   // príchod ešte neprešiel — skús v ďalšom kole
          const r = await fetchAuth('/api/dochadzka/' + encodeURIComponent(id) + '/koniec', { method: 'PATCH', body: JSON.stringify(it.body) })
          const d = await r.json().catch(() => ({}))
          if (r.ok) { await doDel(it.client_uid); sent++ }
          else if (r.status >= 400 && r.status < 500) { await doPut({ ...it, err: d.error || ('Chyba ' + r.status) }) }
          else break
        }
      } catch (_) { break }   // bez siete — skús neskôr
    }
  } finally { flushing = false }
  return { sent }
}
